(function () {


	window.addEventListener('DOMContentLoaded', function () {
		function Accordion(view){
			if (view) {
				
				let linkArr = esriClientUtils.selectAll('.faq-accordion-item-section',view);
				let sectArr = esriClientUtils.selectAll('.accordion-title',view);
				let openClose = esriClientUtils.select('.show-hide-all',view);
				let textinfo = esriClientUtils.select('.openCloseText',view);
				let allArrow = esriClientUtils.select('.show-hide-caret',view);
				let openCloseAttr = openClose.getAttribute('aria-hidden');

				let hideAll = (link, isFalse) => {
					openClose.setAttribute('aria-hidden', 'false');
					textinfo.innerHTML = "Hide All";
					allArrow.classList.remove('icon-ui-down');
					allArrow.classList.add('icon-ui-up');
					if (isFalse) { 
						link.classList.add('is-active'); 
					}
				}

				let showAll = (link, isTrue) => {
					openClose.setAttribute('aria-hidden', 'true');
					textinfo.innerHTML = "Show All";
					allArrow.classList.remove('icon-ui-up');
					allArrow.classList.add('icon-ui-down');
					if (isTrue) {
						link.classList.remove('is-active');
					}
				}

				sectArr.forEach(el => {
					el.addEventListener('click', (evt) => {
						let sectCount = esriClientUtils.select('.faq-accordion--content',view);
						let sectExpanded = sectCount.querySelectorAll('.faq-accordion-item-section.is-active').length;
						let sectTotal = sectCount.querySelectorAll('.faq-accordion-item-section').length;
						const half = 2;
						
						(sectExpanded > (sectTotal/half)) ? hideAll() : showAll();
						
						openCloseAttr = openClose.getAttribute('aria-hidden');
					
					});
				});
				
			
					openClose.addEventListener('click', function (event) {
						if (openCloseAttr === "true") {
							linkArr.forEach(function (link) { hideAll(link, true) });
						} else if (openCloseAttr === "false") {
							linkArr.forEach(function (link) { showAll(link, true) });
						}
						openCloseAttr = openClose.getAttribute('aria-hidden');
					});
			};

		}
		var accordions = esriClientUtils.selectAll(".faq-accordion--outer");
		accordions.forEach(function(accordion){
			new Accordion(accordion);
		});
	});
})();